import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";

/**
 * Reusable Profile Dropdown Component
 * Used in both mobile and desktop navigation headers
 * Features: User info, profile link, admin panel (if admin)
 * Note: isApprovedAffiliate is passed from parent to avoid flicker on dropdown open
 */
const ProfileDropdown = ({
  isMobile = false,
  onClose,
  className = "",
  isApprovedAffiliate = false,
}) => {
  const { user, isAdmin } = useAuth();
  const navigate = useNavigate();

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  const baseClasses = isMobile
    ? "fixed left-0 right-0 top-16 bg-card border-b border-border shadow-lg z-50"
    : "absolute right-0 mt-2 w-48 bg-card border border-border rounded-lg shadow-lg z-50";

  return (
    <div className={`${baseClasses} ${className}`}>
      <div className="py-1">
        {/* User Info Header */}
        <div className="px-4 py-2 border-b border-border">
          <div className="text-sm font-medium text-white">
            {user?.user_metadata?.first_name || user?.username || "Player"}
          </div>
          <div className="text-xs text-gray-400">{user?.email}</div>
          <div className="text-xs text-primary font-medium mt-1">
            {isAdmin ? "Administrator" : "Player"}
          </div>
        </div>

        {/* Profile Button */}
        <button
          onClick={() => handleNavigation("/profile")}
          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-muted transition-colors cursor-pointer"
        >
          Profile
        </button>

        {/* VIP Button */}
        <button
          onClick={() => handleNavigation("/vip")}
          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-muted transition-colors cursor-pointer"
        >
          VIP
        </button>

        {/* Redeem Button */}
        <button
          onClick={() => handleNavigation("/redeem")}
          className="w-full text-left px-4 py-2 text-sm text-white hover:bg-muted transition-colors cursor-pointer"
        >
          Redeem
        </button>

        {/* Affiliate Dashboard for approved affiliates, Refer a Friend for others */}
        {isApprovedAffiliate ? (
          <button
            onClick={() => handleNavigation("/affiliate")}
            className="w-full text-left px-4 py-2 text-sm text-white hover:bg-muted transition-colors cursor-pointer"
          >
            Affiliate
          </button>
        ) : (
          <button
            onClick={() => handleNavigation("/refer")}
            className="w-full text-left px-4 py-2 text-sm text-white hover:bg-muted transition-colors cursor-pointer"
          >
            Refer a Friend
          </button>
        )}

        {/* Admin Panel Button - Only show for admins */}
        {isAdmin && (
          <button
            onClick={() => handleNavigation("/admin")}
            className="w-full text-left px-4 py-2 text-sm text-white hover:bg-muted transition-colors cursor-pointer"
          >
            Admin Panel
          </button>
        )}
      </div>
    </div>
  );
};

export default ProfileDropdown;
